/* eslint-disable react/require-default-props */
import React, { useState, Suspense } from 'react';
import PropTypes from 'prop-types';
import {
  params, string, shape, bool, useDataModel
} from '@thd-nucleus/data-sources';
import { Alert, Link, Typography } from '@one-thd/sui-atomic-components';

const Overlay = React.lazy(() => import(/* webpackChunkName: "overlay" */ '@thd-olt-component-react/overlay')
  .then((module) => ({ default: module.Overlay })));

// eslint-disable-next-line max-len
const DisclaimerMessageContent = React.lazy(() => import(/* webpackChunkName: "disclaimer-message-content" */ './DisclaimerMessageContent')
  .then((module) => ({ default: module.DisclaimerMessageContent })));

const DisclaimerMessage = ({ itemId = null }) => {
  const [open, setOpen] = useState(false);
  const { data, loading, error } = useDataModel('product', { variables: { itemId } });

  if (!data || !data?.product?.info?.forProfessionalUseOnly || loading || (error && !data)) {
    return null;
  }

  return (
    <div
      className="sui-mb-8 sui-max-w-fit"
      data-component="DisclaimerMessage"
    >
      <Alert status="warning">
        <div className="sui-flex sui-flex-col">
          <Typography variant="body-base" weight="bold">
            This product is for professional and commercial use only.
          </Typography>
          <div className="sui-flex sui-flex-row">
            <Typography variant="body-base">
              Please review our
            </Typography>
            <div className="sui-px-1">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link align="center" onClick={() => setOpen(true)}>
                legal disclaimer
              </Link>
            </div>
            <Typography variant="body-base">
              before purchasing this product.
            </Typography>
          </div>
        </div>
      </Alert>
      {open && (
        <Suspense fallback={(<div />)}>
          <Overlay
            closeButton
            open={open}
            medium
            onClose={() => setOpen(false)}
            header="Legal Disclaimer"
          >
            <Suspense fallback={(<div />)}>
              <DisclaimerMessageContent is3M={data?.product?.identifiers?.brandName === '3M'} />
            </Suspense>
          </Overlay>
        </Suspense>
      )}
    </div>
  );
};

DisclaimerMessage.displayName = 'DisclaimerMessage';

DisclaimerMessage.dataModel = {
  product: params({ itemId: string().isRequired(), dataSource: string() }).shape({
    itemId: string(),
    info: shape({
      forProfessionalUseOnly: bool()
    }),
    identifiers: shape({
      brandName: string()
    })
  })
};

DisclaimerMessage.propTypes = {
  itemId: PropTypes.string
};

export { DisclaimerMessage };
